import { render } from "./DeliveryTable.vue?vue&type=template&id=5f69ed22"
import script from "./DeliveryTable.vue?vue&type=script&lang=js"
export * from "./DeliveryTable.vue?vue&type=script&lang=js"

import "./DeliveryTable.vue?vue&type=style&index=0&id=5f69ed22&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__